export const Spacings = {
    NONE: 'none',
    SMALL: 'small',
    MEDIUM: 'medium',
    BIG: 'big',
};
Object.freeze(Spacings);

export const SPACING_OPTIONS = [
    { label: 'None', value: Spacings.NONE },
    { label: 'Spacing small', value: Spacings.SMALL },
    { label: 'Spacing medium', value: Spacings.MEDIUM },
    { label: 'Spacing big', value: Spacings.BIG },
];

export const SPACING_PREF = 'spacing';



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/common/spacings.js